import React from 'react'

const Icon: React.FC<any> = ({ ...props }) => {
  return (
    <svg {...props} viewBox="0 0 28 28">
      <g clipPath="url(#clip0)">
        <path d="M14 27.4444C21.4227 27.4444 27.44 21.4251 27.44 14C27.44 6.57482 21.4227 0.555542 14 0.555542C6.57729 0.555542 0.559998 6.57482 0.559998 14C0.559998 21.4251 6.57729 27.4444 14 27.4444Z M7.64856 20.2495L20.0823 7.81569 M19.9535 20.3582L7.69696 8.10168" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Icon
